import clsx from 'clsx';
import styles from './Button.module.css';

export function Button({
  children,
  className = '',
  onClick,
  size = 'sm',
  type = 'button',
  variant = 'primary',
  ...rest
}) {
  const sizeClass = size === 'sm' ? styles.sm : styles.md;
  const variantClass =
    variant === 'primary'
      ? styles.primary
      : variant === 'outline'
        ? styles.outline
        : variant === 'outlineDelete'
          ? styles.outlineDelete
          : variant === 'danger'
            ? styles.danger
            : styles.default;

  return (
    <button
      className={clsx(styles.button, variantClass, sizeClass, className)}
      onClick={onClick}
      type={type}
      {...rest}
    >
      {children}
    </button>
  );
}
